import { ChangeDetectionStrategy, Component, inject, output, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { RichEditorDualLangTextAreaComponent } from '../../../../../../ui-components/lib/rich-editor-dual-lang-text-area/rich-editor-dual-lang-text-area.component';
import { baseUrl } from '../../../../../common/constants/endpoints.constants';

@Component({
  selector: 'lib-approve-modal',
  imports: [
    ReactiveFormsModule,
    TranslocoPipe,
    RichEditorDualLangTextAreaComponent,
  ],
  templateUrl: './approve-modal.component.html',
  styleUrl: './approve-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ApproveModalComponent {
  translocoService = inject(TranslocoService);
  fb = inject(FormBuilder);
  closeModal = output<void>();
  submitApprove = output<any>();
  baseUrl = baseUrl;
  approveForm = signal<FormGroup>(
    this.fb.group({
      comment: ['', []],
    })
  );

  onSubmit(): void {
    if (this.approveForm().valid) {
      const formValue = this.approveForm().getRawValue();
      this.submitApprove.emit(formValue);
    } else {
      this.approveForm().markAsDirty();
      this.approveForm().markAllAsTouched();
    }
  }

  onClose(): void {
    this.closeModal.emit();
  }
}
